var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { countBy } from "lodash";
import Button, { IconButton } from "@irati/ui/src/Button";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H2, H4 } from "@irati/ui/src/Headings";
import Flex from "@irati/ui/src/Flex";
import { FIRSTNAME, EMAIL } from "@irati/admin/helpers/userCSV";
import Column from "./Column/Column";
import { Columns, Error, TableContainer } from "./styled";
var AddPeopleHeaders = /** @class */ (function (_super) {
    __extends(AddPeopleHeaders, _super);
    function AddPeopleHeaders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasRequired = function () {
            var _a = _this.props, headers = _a.headers, requiredHeaders = _a.requiredHeaders;
            return countBy(headers.map(function (header) { return !!requiredHeaders.find(function (requiredHeader) { return requiredHeader === header; }); })).true === requiredHeaders.length;
        };
        return _this;
    }
    AddPeopleHeaders.prototype.renderTitle = function () {
        var _a = this.props, formatMessage = _a.formatMessage, headers = _a.headers;
        var hasHeaders = headers.every(function (value) { return !!value; });
        if (hasHeaders && this.hasRequired()) {
            return formatMessage({ id: "admin.components.addPeopleHeaders.header.rightDocument" });
        }
        return formatMessage({ id: "admin.components.addPeopleHeaders.header.couldntMatchHeaders" });
    };
    AddPeopleHeaders.prototype.render = function () {
        var _a = this.props, requiredMessage = _a.requiredMessage, buttonText = _a.buttonText, headers = _a.headers, options = _a.options, updateHeader = _a.updateHeader, isLoading = _a.isLoading, submitUsers = _a.submitUsers, usersLength = _a.usersLength, csv = _a.csv, alignLeft = _a.alignLeft, back = _a.back;
        var HeaderWrapper = alignLeft ? Flex : React.Fragment;
        return (React.createElement(Flex, { justifyContent: alignLeft ? "flex-start" : "center", direction: "column" },
            React.createElement(HeaderWrapper, { alignItems: "center", margin: "0 0 30px 0" },
                back && React.createElement(IconButton, { onClick: back, icon: "backArrow" }),
                React.createElement(H2, { margin: alignLeft ? "0 0 0 15px" : "0 auto 15px" },
                    React.createElement(FormattedMessage, { id: "admin.components.addPeopleHeaders.headerFour.mapColumns" }))),
            React.createElement(H4, { base: true, margin: !alignLeft && "0 auto 15px" }, this.renderTitle()),
            !this.hasRequired() && (React.createElement(Error, { base: true },
                React.createElement(FormattedMessage, { id: requiredMessage }))),
            React.createElement(TableContainer, { alignLeft: alignLeft },
                React.createElement(Columns, null, headers.map(function (header, i) { return (React.createElement(Column, { options: options, key: i, header: header, idx: i, changeHeader: updateHeader, isValid: header }, csv.map(function (value, idx) {
                    var column = Object.keys(value)[i];
                    return (React.createElement("div", { key: idx, className: "header-value" }, value[column]));
                }))); })),
                React.createElement(Button, { primary: true, large: true, disabled: !this.hasRequired() || isLoading, onClick: submitUsers }, isLoading ? (React.createElement(FormattedMessage, { id: "admin.components.addPeopleHeaders.button.uploading" })) : (React.createElement(FormattedMessage, { id: buttonText, values: { usersLength: usersLength } }))))));
    };
    AddPeopleHeaders.defaultProps = {
        headers: [],
        csv: [],
        isLoading: false,
        options: null,
        requiredHeaders: [FIRSTNAME, EMAIL],
        requiredMessage: "admin.components.addPeopleHeaders.headerFour.firstNameAndEmail",
        buttonText: "admin.components.addPeopleHeaders.button.invite"
    };
    return AddPeopleHeaders;
}(Component));
export default injectIntl(AddPeopleHeaders);
